/**
 *
 * @module mediaThumbnailLinks
 *
 */

import Check from 'check-types';

import MediaThumbnailLink from './mediaThumbnailLink';

import Exception from './../exception/entry';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    object
} = Check.assert;

/**
 *
 * @class MediaThumbnailLinks
 *
 */
export default class MediaThumbnailLinks {

    /**
     * @param {Object} thumbnails
     * @note If the playlist service response contains a `thumbnails` object we will try to construct one or both of
     * the properties in this file. These properties will be used when attempting to fetch thumbnails.
     * @note both `spritesheet` and `bif` are optional
     *
     */
    constructor(thumbnails) {

        const errorMessage = {
            ctor: 'MediaThumbnailLinks(thumbnails)',
            get thumbnails() {
                return `${this.ctor} thumbnails should be an Object`;
            }
        };

        object(thumbnails, errorMessage.thumbnails, InvalidArgumentException);

        const { bif, spritesheet } = thumbnails;

        /**
         *
         * @access public
         * @type {SDK.Services.Media.MediaThumbnailLink|null}
         * @desc response from the playlist service used to fetch a thumbnail presentation
         *
         */
        this.bif = Check.assigned(bif) ? new MediaThumbnailLink(bif) : null;

        /**
         *
         * @access public
         * @type {SDK.Services.Media.MediaThumbnailLink|null}
         * @desc response from the playlist service used to fetch a thumbnail presentation
         *
         */
        this.spritesheet = Check.assigned(spritesheet) ? new MediaThumbnailLink(spritesheet) : null;

    }

}



// WEBPACK FOOTER //
// ./src/services/media/mediaThumbnailLinks.js